import { render, staticRenderFns } from "./CertResult.vue?vue&type=template&id=ff1ec91a"
import script from "./CertResult.vue?vue&type=script&lang=js"
export * from "./CertResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports